import React, { useEffect, useState } from 'react'
import download from '../../assets/img/icon/download.png'
export default function DownloadSection ({
  image,
  pdfLink,
  gradient,
  subjectPassed,
  text1,
  text2,
  text3,
  attachText,
  bonus,
  ccEmail
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [name, setName] = useState('')
  const [errors, setErrors] = useState({ email: '', phone: '', name: '' })
  const [loading, setLoading] = useState(false) // State for loading
  const [countdown, setCountdown] = useState(0);

  const callForm = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setEmail('')
    setPhone('')
    setName('')
    setErrors({ email: '', phone: '', name: '' })
    setCountdown(0);
  }

  const validateEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const validatePhone = phone => {
    return /^\d{8,12}$/.test(phone)
  }

  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [countdown]);

  const handleInputChange = (setter, field, value) => {
    setter(value)

    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: value.trim() === '' ? 'Энэ талбарыг бөглөнө үү' : ''
    }))

    if (field === 'email' && value) {
      setErrors(prevErrors => ({
        ...prevErrors,
        email: validateEmail(value) ? '' : 'Зөв и-мейл хаяг оруулна уу'
      }))
    }

    if (field === 'phone' && value) {
      setErrors(prevErrors => ({
        ...prevErrors,
        phone: validatePhone(value)
          ? ''
          : 'Зөв утасны дугаар оруулна уу (8-12 цифр)'
      }))
    }
  }

  const isFormValid = () => {
    return name.trim() !== '' && validateEmail(email) && validatePhone(phone)
  }

  const subscribe = async () => {
    if (!isFormValid()) return

    setLoading(true) // Set loading to true when the form is being submitted

    const link = 'https://cellclinic.mn' + pdfLink
    const subject = subjectPassed

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_API_URL}/users/subscribe`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          phone,
          name,
          link,
          subject,
          text1,
          text2,
          text3,
          attachText,
          bonus,
          ccEmail
        })
      }
    )
    setLoading(false)

    if (response.ok) {
      closeModal()
    } else {
    
    }
  }

  return (
    <div
      className='mx-20 flex flex-row mobile:flex-col mobile:mx-5 bg-cover maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto tablet:mx-5 rounded-2xl'
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className='w-[640px]'></div>
      <div className='w-[640px] mobile:w-full flex flex-col p-20 justify-center items-center mobile:p-5 mobile:items-center'>
        <p
          className='text-white text-[28px] text-center mobile:text-[28px] font-inter-bold mobile:text-center mobile:mt-2 
          tablet:text-[16px] tablet:text-center'
          style={{ lineHeight: 1.1 }}
        >
          Дэлгэрэнгүй танилцуулга
        </p>
        <button
          className='flex h-[48px] min-w-[64px] p-4 justify-center items-center gap-0 border
              border-white/55 text-white mt-10 rounded-lg mobile:min-w-[100%] mobile:h-[48px] bg-[#4EB5C6]'
          onClick={callForm}
        >
          <img src={download} alt='Download Icon' className='h-4 w-4 mr-2.5' />
          Татаж авах
        </button>
      </div>

      {isModalOpen && (
        <div className='fixed inset-0 bg-black/50 flex justify-center items-center'>
          <div className='bg-white p-8 rounded-lg w-[400px]'>
            <h2 className='text-lg font-bold'>
              Мэдээллээ оруулна уу. Танилцуулгыг таны и-мейл хаяг руу илгээнэ.
            </h2>
            <p className='text-[12px] mb-4 text-red-500'>И-мейл таны cпам фолдерт орсон байж болзошгүй.</p>
            <form onSubmit={e => e.preventDefault()}>
              <div className='mb-4'>
                <label className='block text-sm font-medium text-gray-700'>
                  Нэр
                </label>
                <input
                  type='text'
                  value={name}
                  onChange={e =>
                    handleInputChange(setName, 'name', e.target.value)
                  }
                  className='w-full px-4 py-2 border border-gray-300 rounded-md mt-2'
                  required
                />
                {errors.name && (
                  <p className='text-red-500 text-sm'>{errors.name}</p>
                )}
              </div>
              <div className='mb-4'>
                <label className='block text-sm font-medium text-gray-700'>
                  И-мейл
                </label>
                <input
                  type='email'
                  value={email}
                  onChange={e =>
                    handleInputChange(setEmail, 'email', e.target.value)
                  }
                  className='w-full px-4 py-2 border border-gray-300 rounded-md mt-2'
                  required
                />
                {errors.email && (
                  <p className='text-red-500 text-sm'>{errors.email}</p>
                )}
              </div>
              <div className='mb-4'>
                <label className='block text-sm font-medium text-gray-700'>
                  Утасны дугаар
                </label>
                <input
                  type='tel'
                  value={phone}
                  onChange={e =>
                    handleInputChange(setPhone, 'phone', e.target.value)
                  }
                  className='w-full px-4 py-2 border border-gray-300 rounded-md mt-2'
                  required
                />
                {errors.phone && (
                  <p className='text-red-500 text-sm'>{errors.phone}</p>
                )}
              </div>
              <div className='flex justify-between'>
                <button
                  type='button '
                  className='text-red-500 hover:text-red-700  rounded-md border px-4'
                  onClick={closeModal}
                >
                  Хаах
                </button>
                  <button type="button"
                        className={`bg-blue-500 text-white px-4 py-2 rounded-md ${!isFormValid() || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={subscribe} disabled={!isFormValid() || loading}>
                  {loading ? (
                    <span className="text-white">
                      {countdown > 0 ? `Түр хүлээнэ үү... ${countdown} секунд` : 'Илгээж байна...'}
                    </span>
                  ) : (
                    'Татаж авах'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
